export default __webpack_public_path__ + "static/media/norway.dc2d0a4b.svg";